import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowPopup } from "./arrowPopup";
import * as S from "./sizesPopup.styles";
import { MenuButton } from "./menuButton";
function Item(props) {
    return (_jsx(S.FixedItem, { children: _jsx(MenuButton, Object.assign({}, props)) }));
}
export function SizesPopup({ items, selection, onChange }) {
    return (_jsx(ArrowPopup, { children: _jsx(S.Wrapper, { children: items.map((item) => {
                const isSelected = item.size === selection;
                return (_jsx(Item, { isSelected: isSelected, onClick: () => {
                        if (!isSelected) {
                            onChange(item.id);
                        }
                    }, text: item.size }, item.id));
            }) }) }));
}
